<template>
  <div class="page-compact">
    <crm-panel :title="'支出合同列表'">
      <div class="page-buttons">
        <crm-button
          v-if="auth.contractSupportAdd && auth.contractSupportAdd.toggleStatus"
          :buttonType="'secondary'"
          :text="'新增'"
          @click="addCompactDialogVisible = true"
        >
        </crm-button>
        <crm-button
          v-if="
            auth.contractSupportExport &&
              auth.contractSupportExport.toggleStatus
          "
          :buttonType="'plain'"
          :text="'导出'"
          :disabled="isExportDisabled"
          @click="handleExport()"
        >
        </crm-button>
      </div>
      <!-- 搜索条 -->
      <div class="mt20">
        <el-form ref="searchForm" :model="searchForm" :inline="true">
          <el-form-item label="">
            <div class="select-data-picker">
              <el-date-picker
                value-format="yyyy-MM-dd"
                :editable="false"
                v-model="searchTime"
                type="daterange"
                range-separator="至"
                start-placeholder="签订日期始"
                end-placeholder="签订日期止"
              >
              </el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="">
            <el-input
              placeholder="根据名称查询"
              v-model="searchName"
              class="input-with-select"
            >
              <el-select v-model="searchNameType" slot="prepend">
                <el-option
                  v-for="item in options"
                  :key="item.label"
                  :label="item.value"
                  :value="item.label"
                >
                </el-option>
              </el-select>
              <i
                slot="suffix"
                class="el-input__icon el-icon-search"
                @click="handleSearch"
                style="cursor: pointer"
              ></i>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <!-- 合同列表 -->
      <el-table
        :data="spendDataList && spendDataList.results"
        height="100%"
        v-loading="loading"
        style="width: 100%"
      >
        <el-table-column
          show-overflow-tooltip
          fixed="left"
          label="合同编号"
          prop="contractNo"
          width="200"
          align="center"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="supplierName"
          label="供应商名称"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="contractAmount"
          align="center"
          label="合同金额（元）"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="signedDateStr"
          align="center"
          label="签订日期"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="settlementName"
          align="center"
          label="结算方式"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="150"
          prop="remarks"
          align="center"
          label="备注"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="salesmanName"
          align="center"
          label="业务员"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="teamName"
          width="130"
          align="center"
          label="所属团队"
        >
        </el-table-column>
        <el-table-column fixed="right" width="100" align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              v-if="
                auth.contractSupportUpdate &&
                  auth.contractSupportUpdate.toggleStatus
              "
              @click="handleUpdate(scope)"
              type="text"
              size="small"
            >
              编辑
            </el-button>
            <el-button
              v-if="
                auth.contractSupportDelete &&
                  auth.contractSupportDelete.toggleStatus
              "
              @click="handleDelete(scope)"
              type="text"
              size="small"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 合同列表分页 -->
      <div class="pageination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pagenation.pageNumber"
          :page-sizes="[10, 20, 50]"
          :page-size="10"
          layout="total, sizes, prev, pager, next"
          :total="(spendDataList && spendDataList.totalCount) || 0"
        >
        </el-pagination>
      </div>
    </crm-panel>

    <!-- 新增合同弹窗 -->
    <add-spend
      v-if="addCompactDialogVisible"
      :id="compactId"
      @close="handleCloseCompactDialog"
      @success="handleRefreshCompact()"
    >
    </add-spend>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import config from '~config';
import { downloadByUrl } from '@/scripts/utils';
import AddSpend from '~component/business/compact/AddSpend.vue';
import crmPanel from '~component/base/crmPanel.vue';
import crmButton from '~component/base/crmButton.vue';

export default {
  components: {
    AddSpend,
    crmPanel,
    crmButton,
  },
  data() {
    return {
      loading: false,
      searchName: '',
      searchTime: [],
      searchDateType: 1,
      searchNameType: 'supplierName',
      options: [
        {
          value: '供应商名称',
          label: 'supplierName',
        },
        {
          value: '合同编号',
          label: 'contractNo',
        },
        {
          value: '业务员',
          label: 'salesmanName',
        },
      ],
      // 搜索表单
      searchForm: {},
      // 分页
      pagenation: {
        pageNumber: 1,
        pageSize: 10,
      },
      isExportDisabled: false,
      // 合同详情
      detailTabName: null,
      detailId: '',
      compactDetailVisible: false,
      // 查看客户详情
      customDetailShow: false,
      // 客户查看面板
      customRow: {},
      viewPanel: {
        uid: '',
        type: 1,
        teamId: 1,
        authEdit: true,
        authDelete: true,
      },
      addCompactDialogVisible: false,
      updateCompactDialogVisible: false,
      compactId: '',
      contractType: '',
    };
  },
  computed: {
    ...mapGetters({
      auth: 'authority/auth',
      spendDataList: 'compact/spendDataList',
    }),
  },
  watch: {
    searchTime: {
      handler: 'handleSearch',
    },
  },
  created() {
    this.handleSearch();
  },
  methods: {
    ...mapActions({
      getContractSupport: 'compact/getContractSupport',
      exportApiSupport: 'compact/exportApiSupport',
      deleteApiSupport: 'compact/deleteApiSupport',
    }),
    handleExport() {
      this.isExportDisabled = true;
      this.notify = this.$notify({
        iconClass: 'el-icon-loading',
        title: '',
        message: '正在导出中，请稍后...',
        duration: 0,
        showClose: false,
      });
      this.handleSearchData();
      const params = {
        ...this.pagenation,
        ...this.searchForm,
      };

      let url = `${config.api || ''}/api/contractSupport/export?`;
      Object.keys(params).forEach((item) => {
        if (params[item]) url += `${item}=${params[item]}&`;
      });

      downloadByUrl(url);
      this.isExportDisabled = false;
      if (this.notify) this.notify.close();
    },
    handleCloseCompactDialog() {
      this.addCompactDialogVisible = false;
      this.compactId = '';
    },
    // 搜索按钮
    handleSearch() {
      this.pagenation.pageNumber = 1;
      this.handleGetCompactList();
    },
    // 根据条件刷新合同列表
    handleGetCompactList() {
      this.loading = true;
      this.handleSearchData();

      this.getContractSupport({
        ...this.pagenation,
        ...this.searchForm,
        $_priority: 10,
      }).finally(() => {
        this.loading = false;
      });
    },
    // 处理搜索数据
    handleSearchData() {
      // if (this.searchTime && this.searchTime.length > 0) {
      //   this.searchForm.startDateStr = this.searchTime[0];
      //   this.searchForm.endDateStr = this.searchTime[1];
      // } else {
      //   delete this.searchForm.startDateStr;
      //   delete this.searchForm.endDateStr;
      // }
      // if (!this.searchName) {
      //   delete this.searchForm[this.searchNameType];
      // } else {
      //   this.searchForm[this.searchNameType] = this.searchName;
      // }
      this.searchForm = {
        [this.searchNameType]: this.searchName,
        startDateStr:
          this.searchTime && this.searchTime.length > 0
            ? this.searchTime[0]
            : '',
        endDateStr:
          this.searchTime && this.searchTime.length > 0
            ? this.searchTime[1]
            : '',
      };
    },
    // 分页 每页显示条数
    handleSizeChange(val) {
      this.pagenation.pageSize = val;
      this.pagenation.pageNumber = 1;

      this.handleGetCompactList(this.pagenation);
    },
    // 分页，当前页改变
    handleCurrentChange(val) {
      this.pagenation.pageNumber = val;
      this.handleGetCompactList(this.pagenation);
    },
    // 编辑
    handleUpdate(scope) {
      this.compactId = scope.row.id;
      this.addCompactDialogVisible = true;
    },
    handleRefreshCompact() {
      this.handleGetCompactList();
    },
    // 删除合同
    handleDelete(scope) {
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.deleteApiSupport({ id: scope.row.id }).then(() => {
            this.handleGetCompactList();
            this.$message({
              type: 'success',
              message: '删除成功!',
            });
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/styles/var.less';
@import '~@/styles/const.less';

.page-compact {
  display: flex;
  flex: 1;
  width: 100%;
  overflow: hidden;
  .el-checkbox {
    color: rgba(0, 0, 0, 0);
  }
}
</style>
